<template>
  <b-modal id="saveModal" title="Speichern">
    <!-- <p class="my-4">Hello from modal!</p> -->
    <input
      type="text"
      class="col-10 form-control"
      id="clientName"
      placeholder="Client Name"
      v-model="clientName"
      ref="clientName"
    />
    <template v-slot:modal-footer="{ ok, cancel }">
      <div>
        <button type="button" class="btn btn-secondary mr-2" @click="cancel()">
          Abbrechen
        </button>
        <button
          type="button"
          class="btn btn-primary"
          @click="
            save();
            ok();
          "
        >
          Speichern
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "ModalSave",
  data() {
    return {};
  },
  computed: {
    clientName: {
      get() {
        // console.log(this.row1value);
        return this.$store.state.clientName;
      },
      set(value) {
        this.$store.commit("setClientName", value);
      }
    }
  },
  methods: {
    save() {
      this.$store.dispatch("saveNew");
      this.$router.push("/Kostentraegerstammdaten");
    }
  }
};
</script>
